export default "__VITE_ASSET__CYSeShQ9__"